<template>
  <div class="detail-view">
    <!-- 基本信息 -->
    <div class="group-title">基本信息</div>
    <div class="group-view">
      <a-row>
        <a-col :span="12">
          <div class="col-row"><span>任务ID：</span>{{ detail.id }}</div>
          <div class="col-row"><span>小程序：</span>{{ detail.app_name }}（{{ detail.app_id }}）</div>
          <div class="col-row"><span>开始日期：</span>{{ detail.expiration_time }}</div>
          <div class="col-row">
            <span>任务状态：</span>
            <a-switch
              v-model:checked="detail.status"
              checked-children="开"
              un-checked-children="关"
              @change="onShow($event)"
            />
          </div>
          <div class="col-row"><span>入库时间：</span>{{ detail.store_date }}</div>
        </a-col>
        <a-col :span="12">
          <div class="col-row"><span>渠道：</span>{{ detail.channel && detail.channel.name }}（{{ detail.demand_id }}）</div>
          <div class="col-row"><span>短剧：</span>{{ detail.playlet && detail.playlet.name }} <a @click="onDramaChange">更换</a></div>
          <div class="col-row"><span>结束日期：</span>{{ detail.expiration_time_end }}</div>
          <div class="col-row"><span>星图状态：</span>{{ (XinTuStateTypes.find(item => item.value === detail.challenge_status) || {}).text }}</div>
          <div class="col-row"><span>入库操作：</span>{{ detail.admin_username }}</div>
        </a-col>
      </a-row>
    </div>
    <!-- 任务介绍 -->
    <div class="group-title">任务介绍</div>
    <div class="group-view" style="word-break: break-all; word-wrap: break-word;">{{ detail.demand_desc }}</div>
    <!-- 分成规则 -->
    <div class="group-title">
      分成规则 <a @click="touchInWarehouse">修改</a>
    </div>
    <div class="group-view">
      <a-row>
        <!-- IAP -->
        <template v-if="detail.pay_type === 1 || detail.pay_type === 3">
          <a-col :span="12">
            <div class="col-title">IAP（毛利{{ (detail.iap_provider_commission_rate - detail.iap_yx_commission_rate).toFixed(2) }}%）</div>
            <div class="col-row"><span>可分成：</span>{{ detail.iap_commission_rate_api }}%（其中服务商占比{{ detail.service_provider_rate_api }}%）</div>
            <div class="col-row"><span>服务商星图分成：</span>{{ detail.iap_provider_commission_rate }}%</div>
            <div class="col-row"><span>达人星图分成：</span>{{ detail.iap_xt_commission_rate }}%</div>
            <div class="col-row"><span>达人云想分成：</span>{{ detail.iap_yx_commission_rate }}%</div>
          </a-col>
        </template>
        <!-- IAA -->
        <template v-if="detail.pay_type === 2 || detail.pay_type === 3">
          <a-col :span="12">
            <div class="col-title">IAA（毛利{{ (detail.iaa_provider_commission_rate - detail.iaa_yx_commission_rate).toFixed(2) }}%）</div>
            <div class="col-row"><span>可分成：</span>{{ detail.iaa_commission_rate_api }}%（其中服务商占比{{ detail.service_provider_rate_api }}%）</div>
            <div class="col-row"><span>服务商星图分成：</span>{{ detail.iaa_provider_commission_rate }}%</div>
            <div class="col-row"><span>达人星图分成：</span>{{ detail.iaa_xt_commission_rate }}%</div>
            <div class="col-row"><span>达人云想分成：</span>{{ detail.iaa_yx_commission_rate }}%</div>
          </a-col>
        </template>
      </a-row>
    </div>
  </div>
  <!-- 任务入库 -->
  <InWarehouse ref="RefInWarehouse" @success="getDetail" />
  <!-- 短剧切换 -->
  <Drama ref="RefDrama" @success="getDetail"></Drama>
</template>

<script setup>
import { onBeforeMount, reactive, ref } from 'vue'
import InWarehouse from '../components-pending-storage/InWarehouse.vue'
import { XinTuStateTypes } from '@/utils/constantList'
import Drama from './Drama.vue'
import { taskDetail, taskStatus } from '@/api/request'

// 入库
let RefInWarehouse = ref(null)
// 短剧
let RefDrama = ref(null)
// 详情
let detail = ref({})
// 回调
const emit = defineEmits('success')
// 接收参数
const props = defineProps({
  // 详情
  detail: {
    type: Object,
    default: () => {}
  }
})

onBeforeMount(() => {
  // 获取详情
  getDetail()
})

// 获取详情
function getDetail () {
  taskDetail({ id: props.detail.id }).then(res => {
    const { code, data } = res
    if (code === 0) {
      data.status = data.status === 1
      detail.value = data
    }
  })
}

// 剧集切换
function onDramaChange () {
  RefDrama.value.showDrawer(detail.value)
}

// 点击修改
function touchInWarehouse () {
  RefInWarehouse.value.showDrawer([detail.value.id], detail.value, true)
}

// 展示开关
function onShow (e) {
  const params = {
    id: detail.value.id,
    status: e ? 1 : 2
  }
  taskStatus(params).then(res => {
    const { code, data, msg } = res
    if (code === 0) {
      if (e) {
        message.success('开启成功')
      } else {
        message.success('关闭成功')
      }
    } else {
      message.error(res.message || msg)
      getDetail()
    }
  }).catch(() => {
    getDetail()
  })
}
</script>

<style lang="less" scoped>
.detail-view {
  width: 100%;
  height: 100%;
  .group-title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 20px;
    a {
      font-size: 13px;
    }
  }
  .group-view {
    color: rgba(0, 0, 0, 0.6);
    margin-bottom: 20px;
    .col-title {
      font-size: 15px;
      font-weight: 700;
    }
    .col-row {
      span {
        color: rgba(0, 0, 0, 0.95);
      }
    }
    .col-row:not(:first-child) {
      margin-top: 15px;
    }
  }
}
</style>